import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Removed TypeScript interfaces

const initialState = {
  communityIssues: [],
  currentCommunityIssue: null,
  loading: false,
  error: null,
};

export const fetchCommunityIssues = createAsyncThunk(
  'communityIssues/fetchCommunityIssues',
  async () => {
    const response = await api.get('/communityIssues/communityIssues');
    return response.data;
  }
);

export const fetchCommunityIssueById = createAsyncThunk(
  'communityIssues/fetchCommunityIssueById',
  async (id) => {
    const response = await api.get(`/communityIssues/communityIssues/${id}`);
    return response.data;
  }
);

export const createCommunityIssue = createAsyncThunk(
  'communityIssues/createCommunityIssue',
  async (communityIssueData) => {
    const response = await api.post('/communityIssues/communityIssues', communityIssueData);
    return response.data;
  }
);

export const updateCommunityIssue = createAsyncThunk(
  'communityIssues/updateCommunityIssue',
  async ({ id, communityIssueData }) => {
    const response = await api.put(`/communityIssues/communityIssues/${id}`, communityIssueData);
    return response.data;
  }
);

export const deleteCommunityIssue = createAsyncThunk(
  'communityIssues/deleteCommunityIssue',
  async (id) => {
    await api.delete(`/communityIssues/communityIssues/${id}`);
    return id;
  }
);

const communityIssueSlice = createSlice({
  name: 'communityIssues',
  initialState,
  reducers: {
    clearCurrentCommunityIssue(state) {
      state.currentCommunityIssue = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunityIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.communityIssues = action.payload;
      })
      .addCase(fetchCommunityIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch community issues';
      })
      .addCase(fetchCommunityIssueById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityIssueById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentCommunityIssue = action.payload;
      })
      .addCase(fetchCommunityIssueById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch community issue';
      })
      .addCase(createCommunityIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCommunityIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.communityIssues.push(action.payload);
      })
      .addCase(createCommunityIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to create community issue';
      })
      .addCase(updateCommunityIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCommunityIssue.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.communityIssues.findIndex((issue) => issue.id === action.payload.id);
        if (index !== -1) {
          state.communityIssues[index] = action.payload;
        }
        if (state.currentCommunityIssue && state.currentCommunityIssue.id === action.payload.id) {
          state.currentCommunityIssue = action.payload;
        }
      })
      .addCase(updateCommunityIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to update community issue';
      })
      .addCase(deleteCommunityIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCommunityIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.communityIssues = state.communityIssues.filter((issue) => issue.id !== action.payload);
        if (state.currentCommunityIssue && state.currentCommunityIssue.id === action.payload) {
          state.currentCommunityIssue = null;
        }
      })
      .addCase(deleteCommunityIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to delete community issue';
      });
  },
});

export const { clearCurrentCommunityIssue } = communityIssueSlice.actions;

export default communityIssueSlice.reducer;
